import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import './Auth.css';

function Login() {
    const [emailOrUsername, setEmailOrUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(emailOrUsername, password);
            navigate('/');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <div className="auth-logo">
                        <div className="logo-icon">
                            <svg width="32" height="32" viewBox="0 0 100 100" fill="none">
                                <defs>
                                    {/* Background gradient */}
                                    <linearGradient id="loginBgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#22d3ee" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#8b5cf6" />
                                    </linearGradient>
                                    {/* Checkmark gradient */}
                                    <linearGradient id="loginCheckGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#06b6d4" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#a855f7" />
                                    </linearGradient>
                                </defs>

                                {/* Main container with rounded corners */}
                                <rect x="10" y="15" width="80" height="72" rx="12" ry="12" fill="url(#loginBgGradient)" />

                                {/* Grid cells - top row (filled) */}
                                <rect x="15" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="40" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="65" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />

                                {/* Grid cells - middle rows (white) */}
                                <rect x="15" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="34" width="20" height="10" rx="2" fill="white" />

                                <rect x="15" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="48" width="20" height="10" rx="2" fill="white" />

                                {/* Grid cells - bottom row (white) */}
                                <rect x="15" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="62" width="20" height="10" rx="2" fill="white" />

                                {/* Large checkmark */}
                                <path d="M50 53 L65 68 L95 30"
                                    stroke="url(#loginCheckGradient)"
                                    strokeWidth="8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    fill="none" />
                            </svg>
                        </div>
                        <span className="logo-text">Spreadsheetr</span>
                    </div>
                    <h1>Sign in to Spreadsheetr</h1>
                    <p>to continue to your dashboard</p>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {error && (
                        <div className="alert alert-error">
                            {error}
                        </div>
                    )}

                    <div className="form-group">
                        <label className="form-label">Email or Username</label>
                        <input
                            type="text"
                            className="form-input"
                            value={emailOrUsername}
                            onChange={(e) => setEmailOrUsername(e.target.value)}
                            placeholder="your.email@company.com or username"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        {loading ? <span className="spinner"></span> : 'Sign In'}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>
                        Don't have an account?{' '}
                        <Link to="/register">Create one</Link>
                    </p>
                </div>
            </div>

            <div className="auth-background">
                <div className="auth-bg-content">
                    <h2>Transform your spreadsheets into robust systems</h2>
                    <ul>
                        <li>Import and analyze spreadsheets</li>
                        <li>Extract rules automatically</li>
                        <li>Validate with parallel testing</li>
                        <li>Audit structural integrity</li>
                        <li>Custom output formatting</li>
                        <li>Multi-user approval workflow</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Login;
